export const inspectData_1 = [
  {
    label: "관리책임자의 현장 배치 적정성",
    is_checked: "",
  },
  {
    label: "품질관리자의 현장 배치 적정성",
    is_checked: "",
  },
  {
    label: "안전관리자의 현장 배치 적정성",
    is_checked: "",
  },
];

export const inspectData_2 = [
  {
    label: "품질관리계획 또는 품질시험계획 수립여부",
    is_checked: "",
  },
  {
    label: "품질시험 이행상태(실적)",
    is_checked: "",
  },
  {
    label: "시험장비 및 검교정 현황",
    is_checked: "",
  },
  {
    label: "철근·철골 사용의 적정성<br />- 한국산업표준에 정한 기준(KS) 이상의 자재 사용여부 (불량 중국산 자재 사용여부 확인)<br />- 품질시험여부 및 그 결과",
    is_checked: "",
  },
];

export const inspectData_3 = [
  {
    label: "지하매설물 관련기관과의 협의 여부<br />- 전력선, 전화케이블, 가스관, 상·하수도관 등 지하매설물의 안전상태 여부",
    is_checked: "",
  },
  {
    label: "화기관리책임자 지정 및 점검상태 이상 유무",
    is_checked: "",
  },
  {
    label: ["광범위한 비상연락망 구축<br />- 발주처, 소방서, 병원 등 유관기관 포함", "현장 비상대기반 편성·운영<br />- 비상사태 시 비상대기반 24시간 운영"],
    is_checked: "",
  },
  {
    label: "비상사태 발생시 대책수립 여부<br />- 근로자 대피계획, 장비 및 자재보호계획 등",
    is_checked: "",
  },
];

export const inspectData_4 = [
  {
    label: "공사용 가설도로 상태의 적정성<br />- 노면의 폭 및 요철부분 정비<br />- 노면의 결빙상태 제거 및 다짐 여부<br />- 동결·융해 반복 시 단부 휀스 설치상태 점검",
    is_checked: "",
  },
  {
    label: "지하매설물 보호조치의 적정성<br />- 노출 상·하수도 관로, 제수변 및 분기개소에 보온 조치 여부<br />- 매설물의 노출부에 노면수 유입방지를 위한 조치 여부<br />- 배관 등 지하매설물 근접 굴착시 안전조치 준수 여부",
    is_checked: "",
  },
];

export const inspectData_5 = [
  {
    label: "강풍 시 타워크레인 작업제한 기준 준수<br />- 순간풍속 10m/s 초과 시 설치·해체, 수리, 점검작업 중지<br />- 순간풍속 15m/s 초과 시 운전작업 중지<br />- 순간풍속 30m/s 초과하는 바람 통과 후에는 작업 개시 전 각 부위 이상 유무 점검",
    is_checked: "",
  },
  {
    label:
      "강풍에 대비한 사전 안전 점검<br />- 타워크레인 등 양중기지지 보강<br />- 가설울타리, 가설사무실 지붕 등의 고정상태 및 지지 보강<br />- 강관비계 벽이음 상태 점검<br />- 갱폼 및 수직보호망 등이 바람의 영향이 없도록 조치<br />- 각종 가설물, 표지판, 자재 등은 견고하게 결속",
    is_checked: "",
  },
];

export const inspectData_6 = [
  {
    label: "안전통로 확보여부<br />- 안전통로 확보 및 사용상태 유지 여부<br />- 통로 주변 안전표지 등 통로 표시 상태",
    is_checked: "",
  },
  {
    label: "비계 상 추락방지<br />- 작업발판 구조 및 안전난간 설치 상태<br />- 추락방호망 설치 상태",
    is_checked: "",
  },
  {
    label: "철골작업시 추락방지<br />- 승강로 설치 상태<br />- 추락방호망 및 안전대 부착설비 설치 상태<br />- 안전대 및 부속설비 이상유무 확인",
    is_checked: "",
  },
  {
    label: "지붕작업시 추락방지<br />- 폭 30cm이상 작업발판 설치 상태<br />- 하부 추락방호망 설치 상태<br />- 지붕단부 안전난간 설치 유무",
    is_checked: "",
  },
  {
    label: "개구부 상의 추락방지<br />- 안전난간, 울타리, 덮개 등 방호조치 설치 상태<br />- 임시로 안전난간 등 해체시 추락방호망 및 안전대 부착설비 설치상태",
    is_checked: "",
  },
  {
    label: "추락예방 개인보호구(안전대, 안전모)<br />- 개인보호구 적정 지급 여부<br />- 지급받은 개인보호구의 적정 착용 여부",
    is_checked: "",
  },
];

export const inspectData_7 = [
  {
    label: "주변지반에 대한 이상유무 점검<br />- 지형, 지질, 지하수위, 용수상태, 주위환경의 이상 유무",
    is_checked: "",
  },
  {
    label: "설계도서의 검토<br />- 원지반의 지질상태, 주변여건 고려 여부<br />- 흙막이 지보공 보강시의 응력상, 시공상 적합성 여부",
    is_checked: "",
  },
  {
    label: "적정 기울기 준수여부<br />- 지반조건, 주변여건을 고려한 적정 굴착 비탈면 기울기 확보",
    table: `<table>
    <tr>
      <th>구분</th>
      <th>지반의 종류</th>
      <th>기울기</th>
    </tr>
    <tr>
      <td rowspan="2" class="td-bg-gray">보통흙</td>
      <td>습지</td>
      <td>1:1 ~ 1:1.5</td>
    </tr>
    <tr>
      <td>건지</td>
      <td>1:0.5 ~ 1:1</td>
    </tr>
    <tr>
      <td rowspan="3" class="td-bg-gray">암반</td>
      <td>풍화암</td>
      <td>1:0.8</td>
    </tr>
    <tr>
      <td>연암</td>
      <td>1:0.5</td>
    </tr>
    <tr>
      <td>경암</td>
      <td>1:0.3</td>
    </tr>
  </table>`,
    is_checked: "",
  },
  {
    label: "측구 및 토공작업구간 배수로 설치 여부",
    is_checked: "",
  },
  {
    label: "굴삭기, 덤프 등 건설장비의 작업계획서 작성 및 유도자 배치",
    is_checked: "",
  },
];

export const inspectData_8 = [
  {
    label: "조립도 작성 및 작업순서 준수 여부",
    is_checked: "",
  },
  {
    label: "조사 및 점검<br />- 부재접합, 교차부 상태 및 부재의 변위탈락 여부<br />- 지지점의 결합상태 이상 유무<br />- 흙막이 판(토류판) 갈라짐, 변형 등 이상 유무<br />- 배면차수 시공 시 최하단부의 용수상태 및 조치 여부",
    is_checked: "",
  },
  {
    label: "지보공(버팀보, 띠장, 앵커 등)의 안전조치 적용 유무<br />- 흙막이 상세 조립도 준수 여부<br />- 버팀대 상부·배면지반에 기계, 자재류 등 중량물 적치 유무<br />- 육안 확인 시 지보공의 이상 징후 발생 유무",
    is_checked: "",
  },
  {
    label: "흙막이 판 설치 시 확인사항<br />- 흙막이판 배면의 공극 유무<br />- 용수로 인하여 흙막이 판이 젖은 부의 보강 여부<br />- 흙막이 판 연결사용 금지조치 이행 여부<br />- 굴착과 동시에 지보공 적기설치 여부",
    is_checked: "",
  },
];

export const inspectData_9 = [
  {
    label:
      "굴착사면 지반상태의 적정성<br />- 사면 구배의 적정성 여부<br />- 동결에 따른 지반팽장으로 절리, 균열부위 발생 등 사면상태의 이상유무<br />- 토석의 붕괴, 낙반위험에 대한 조치 여부<br />- 비탈상부 노면수 유입 방지시설 설치 여부(배수로 측구, 사면 천막비닐 설치 등)",
    is_checked: "",
  },
  {
    label: "침하, 균열, 변형 여부 점검실시<br />- 현장 및 주변 지반에 대하여 최소 1일 1회 이상 순회 점검<br />- 침하, 균열, 변형 발생시 대책 수립 및 시행 여부<br />- 중장비 사용 전 지반 및 가설도로 지내력 확보 방안 수립 여부",
    is_checked: "",
  },
  {
    label: "차량 및 건설기계 등의 전도, 전락방지 조치 실시 여부<br />- 가설숙소<br />- 지하정화조, 저수조, 맨홀, 지하주차장 등",
    is_checked: "",
  },
  {
    label: "비계 또는 거푸집동바리 등 가시설의 설치상태 이상 유무<br />- 외부비계의 연결부, 접속부의 분리·변형 및 클램프 이완 등<br />- 지반 침하로 인한 가설구조물의 변형",
    is_checked: "",
  },
];

export const inspectData_10 = [
  {
    label:
      "거푸집 동바리 구조검토 및 조립도 작성 여부<br />- 고정하중, 활하중 등의 하중산정의 적정성 확인 및 허용하중에 대한 사용 부재의 구조 검토<br />- 시스템동바리의 경우 전체 층고에 대한 좌굴 안전성 검토여부 확인 및 조립도의 가새 설치 여부 확인<br />- 부재의 재질·단면규격·설치간격 등 이음방법 등을 명시",
    is_checked: "",
  },
  {
    label: "거푸집 동바리 조립상태 이상 유무<br />- 구조검토에 의한 조립도 작성<br />- 침하방지, 활동방지 철저",
    is_checked: "",
  },
  {
    label: "거푸집 동바리 재료의 변형, 부식 및 손상 여부<br />- 불량재료의 사용금지<br />- 해체방법, 운반 및 보관방법에 주의",
    is_checked: "",
  },
];

export const inspectData_11 = [
  {
    label: "가설숙소, 현장사무실 및 창고 점검<br />- 난방기구 주변 유류 및 가연성물질 방치 여부<br />- 전기기계·기구의 누전차단기 설치 적정 여부",
    is_checked: "",
  },
  {
    label: "위험물질 관리상태의 적정성<br />- 용접작업 주변 신나, 방수제, 유류 등 인화성, 발화성 물질 방치여부<br />- 위험물질 보관저장소의 위치, 상태 등의 적정성 여부",
    is_checked: "",
  },
  {
    label: "화재예방교육 및 조치 실시 여부<br />- 근로자의 흡연금지 등 근로자에 대한 철저한 화재예방 교육 및 피난교육 실시 여부<br />- 용접작업 시 근로자 교육 및 화재예방조치 실시 여부",
    is_checked: "",
  },
  {
    label: "화재위험작업의 준수사항 이행 및 서면게시, 화재감시자의 배치 여부<br />- 화재위험 작업을 하는 경우 화재위험을 감시하고 화재발생시 근로자 대피를 유도하는 화재감시자를 지정하여 배치",
    is_checked: "",
  },
];
